export default function IconLogoutDone(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (442.084 / 441.776) : 442.084}
      height={height ? height : width ? width * (441.776 / 442.084) : 441.776}
      viewBox="0 0 442.084 441.776"
    >
      <g>
        <g>
          <path
            fill="#2c0313"
            d="M348.425 413.474h-84.922a8.737 8.737 0 0 1 0-17.474h84.922a19.593 19.593 0 0 0 19.57-19.57v-28.307a8.737 8.737 0 1 1 17.474 0v28.307a37.086 37.086 0 0 1-37.044 37.044Z"
          />
          <path
            fill="#2c0313"
            d="M376.732 130.463a8.737 8.737 0 0 1-8.737-8.737V93.419a19.593 19.593 0 0 0-19.57-19.57h-84.922a8.737 8.737 0 1 1 0-17.474h84.922a37.086 37.086 0 0 1 37.044 37.044v28.307a8.737 8.737 0 0 1-8.737 8.737Z"
          />
          <path
            fill="#2c0313"
            d="M192.923 441.777a22.7 22.7 0 0 1-3.682-.3L19.623 418.113a23 23 0 0 1-19.622-22.9V64.536a22.844 22.844 0 0 1 18.008-22.12L187.623.58a23.341 23.341 0 0 1 5.112-.58 22.889 22.889 0 0 1 22.891 22.8v396.282a22.7 22.7 0 0 1-22.7 22.695Zm-.189-424.308a5.428 5.428 0 0 0-1.155.125L21.964 59.432a5.477 5.477 0 0 0-4.491 5.253v330.623a5.462 5.462 0 0 0 4.622 5.51l169.756 23.385 1.072.1a5.228 5.228 0 0 0 5.228-5.226V22.836a5.377 5.377 0 0 0-2.027-4.173 5.437 5.437 0 0 0-3.39-1.194Z"
          />
          <path
            fill="#2c0313"
            d="M433.344 243.663H277.656a8.737 8.737 0 1 1 0-17.474h134.6l-41.7-41.7a8.737 8.737 0 0 1 12.353-12.358l56.614 56.614a8.737 8.737 0 0 1-6.179 14.918Z"
          />
          <path
            fill="#73042d"
            d="M433.344 243.663H277.656a8.737 8.737 0 1 1 0-17.474h134.6l-41.7-41.7a8.737 8.737 0 0 1 12.353-12.358l56.614 56.614a8.737 8.737 0 0 1-6.179 14.918Z"
          />
          <path
            fill="#2c0313"
            d="M376.732 300.268a8.737 8.737 0 0 1-6.178-14.915l56.615-56.614a8.737 8.737 0 1 1 12.355 12.355l-56.614 56.615a8.709 8.709 0 0 1-6.178 2.559Z"
          />
          <path
            fill="#73042d"
            d="M376.732 300.268a8.737 8.737 0 0 1-6.178-14.915l56.615-56.614a8.737 8.737 0 1 1 12.355 12.355l-56.614 56.615a8.709 8.709 0 0 1-6.178 2.559Z"
          />
          <path
            fill="#2c0313"
            d="M133.761 235.999a15.814 15.814 0 0 1 0-31.627v14.154Z"
          />
          <path
            fill="#2c0313"
            d="M133.762 235.999V204.372a15.814 15.814 0 1 1 0 31.627Z"
          />
        </g>
      </g>
    </svg>
  );
}
